<!--
 * @Author: jingfei
 * @Date: 2021-08-24 11:20:15
 * @LastEditTime: 2022-10-13 17:54:59
 * @LastEditors: pingping.mao
 * @Description: Excel导入配置
 * @FilePath: \common-web\src\views\standard\import\import-configuration.vue
-->
<template>
  <div id="import-configuration" class="app-wrap">
    <div v-if="isMain" :span="24" class="equip-account__content h100 overflow-x-y" style="overflow-y: scroll">
      <div class="search">
        <el-form
          :inline="true"
          :model="fileparam"
          size="small"
          class="demo-form-inline"
          @submit.native.prevent
        >
          <!-- 搜索框 -->
          <el-form-item label>
            <el-input
              v-model="fileparam.search"
              clearable
              style="width: 316px"
              :placeholder="$t('excelConfiguration.searchPlaceHolder')"
              @keyup.enter.native="handleSearch"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search cursor-p"
                @click="handleSearch"
              />
            </el-input>
          </el-form-item>

          <!-- 添加文件按钮 -->
          <el-form-item class="float-right" style="margin-right: 0">
            <el-button
              icon="el-icon-circle-plus-outline"
              type="primary"
              @click="
                handleAddRoleShow({
                  type: 'add',
                  data: null
                })
              "
            >
              {{ $t("excelConfiguration.addFile") }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="file-list import-file">
        <!-- 文件列表-->
        <!-- v-if 暂时解决table选择框断线BUG  渲染顺序导致的 -->
        <CustomTable
          v-if="$route.path === '/import/import-configuration'"
          ref="customTable"
          :height="fileList.length === 0 ? '' : '350px'"
          :loading="tableLoading"
          :table-data="fileList"
          :pagination="fileparam"
          :show-pagination="false"
          :checkbox="true"
          :order="true"
          :select-data="selectionData"
          @handleSizeChange="handlePaginationChange"
          @handleCurrentChange="handlePaginationChange"
          @batchDeleteData="deleteFileListData"
          @handleSelectionChange="SelectionChange"
          @rowClick="setCurrentRow"
        >
          <el-table-column prop="code" width="200" :label="$t('excelConfiguration.code')">
            <template slot-scope="scope">
              <el-tooltip
                :content="scope.row.code"
                effect="dark"
                placement="top"
                popper-class="import_excel_tooltip"
              >
                <span class="span_overflow">{{ scope.row.code }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="name" width="100" :label="$t('excelConfiguration.name')" />
          <el-table-column
            prop="manageStyle"
            width="120"
            :label="$t('excelConfiguration.configurationMethod')"
          />
          <el-table-column width="120" :label="$t('excelConfiguration.controllingThingsWay')">
            <template slot-scope="scope">
              <p>
                {{
                  scope.row.transactionType == "ALL"
                    ? "全部成功"
                    : scope.row.transactionType == "ROW"
                      ? "允许单行成功"
                      : "允许SHEET成功"
                }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="description" :label="$t('common.description')">
            <!-- <template slot-scope="scope">
              <CellTooltip :text="scope.row.fileDescription" :width="280"/>
            </template>-->
          </el-table-column>
          <el-table-column
            prop="customClass"
            :label="$t('excelConfiguration.userDefinedProcessingClass')"
          >
            <template slot-scope="scope">
              <el-tooltip
                :content="scope.row.customClass"
                effect="dark"
                placement="top"
                popper-class="import_excel_tooltip"
              >
                <span class="span_overflow">
                  {{ scope.row.customClass }}
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column :label="$t('public.operation')" width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="cursor-p"
                size="small"
                @click="
                  handleAddRoleShow({
                    type: 'edit',
                    data: scope.row
                  })
                "
              >
                {{ $t("common.edit") }}
              </el-button>
              <el-button
                type="text"
                class="cursor-p"
                size="small"
                style="color: red"
                @click="
                  handleDelete({
                    type: 'file',
                    data: scope.row
                  })
                "
              >
                {{ $t("common.delete") }}
              </el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column  width="50" >
            <template slot-scope="scope">
              <el-popover
                placement="bottom"
                trigger="hover"
                style="margin-left: 15px;"
                class="cursor-p self-popover hover_popover"
                :visible-arrow="false"
              >
                <span slot="reference">
                  <i class="el-icon-more" style="transform: rotate(90deg);" />
                </span>
                <div class="self-popover-items">
                  <p
                    class="self-popover-item font_14"
                    style="color: red;"
                    @click="handleDelete({
                      type:'file',
                      data:scope.row
                    })"
                  >
                    {{ $t("common.delete") }}
                  </p>
                </div>
              </el-popover>
            </template>
          </el-table-column>-->
        </CustomTable>
      </div>

      <div class :style="{ height: '52px', marginTop: '16px', overflow: 'hidden' }">
        <pagination
          v-show="fileList && fileparam.total >= 20"
          :style="{ float: 'left', padding: 0 }"
          :page-info="fileparam"
          size="small"
          @size-change="handlePaginationChange"
          @current-change="handlePaginationChange"
        />
        <el-form :inline="true" class="demo-form-inline" size="small" style="float: right">
          <el-form-item label></el-form-item>
          <el-form-item class="float-right" style="margin-right: 0">
            <!-- <el-button icon="el-icon-document-add" @click="submitSaveData()">
              {{ $t("excelConfiguration.saveData") }}
            </el-button> -->

            <el-button type="primary" @click="initSheetList">
              <svg-icon icon-class="data-init"></svg-icon>
              {{ $t("excelConfiguration.initializeSheet") }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="file-list">
        <!-- sheet列表-->
        <CustomTable
          ref="customTable"
          class="sheet_table"
          :checkbox="false"
          :order="false"
          :loading="tableLoading"
          :table-data="sheetList"
          :show-pagination="false"
          @handleSizeChange="handlePaginationChange"
          @handleCurrentChange="handlePaginationChange"
          @batchDeleteData="deleteSheetListData"
          @handleSelectionChange="SelectionChangeSheet"
        >
          <el-table-column prop="sheetName" :label="$t('excelConfiguration.sheetName')" />

          <el-table-column :label="$t('excelConfiguration.sheetTableName')">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.tableName"
                size="mini"
                height="28px"
                :placeholder="$t('excelConfiguration.defaultValue')"
                @focus="blurSearch(scope.row)"
              >
                <svg-icon
                  slot="suffix"
                  class="suffix_icon"
                  icon-class="input_suffix"
                  @click="blurSearch(scope.row)"
                ></svg-icon>
                <!-- <el-button
                  slot="append"
                  size="mini"
                  class="input-solt-btn"
                  @click="blurSearch(scope.row)"
                  icon="el-icon-search"
                ></el-button> -->
              </el-input>
            </template>
          </el-table-column>

          <el-table-column width="100" :label="$t('excelConfiguration.lineNumber')">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.titleLine"
                size="mini"
                controls-position="right"
                style="width: 100%"
                :placeholder="$t('excelConfiguration.defaultValue')"
              ></el-input-number>
            </template>
          </el-table-column>

          <el-table-column width="100" :label="$t('excelConfiguration.updateStatus')">
            <template slot-scope="scope">
              <el-select v-model="scope.row.isUpdate" size="mini" placeholder="请选择">
                <el-option
                  v-for="item in whetherList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column :label="$t('public.operation')" width="130">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="cursor-p"
                size="mini"
                @click="submitSaveData(scope.row)"
              >
                {{ $t("excelConfiguration.propertySetting") }}
              </el-button>
              <el-button
                type="text"
                style="color: red"
                size="mini"
                @click="
                  handleDelete({
                    type: 'sheet',
                    data: scope.row
                  })
                "
              >
                {{ $t("common.delete") }}
              </el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column  width="50">
            <template slot-scope="scope">
              <el-popover
                placement="bottom"
                trigger="hover"
                style="margin-left: 15px;"
                class="cursor-p self-popover hover_popover"
                :visible-arrow="false"
              >
                <span slot="reference">
                  <i class="el-icon-more" style="transform: rotate(90deg);" />
                </span>
                <div class="self-popover-items">
                  <p
                    class="self-popover-item font_14"
                    style="color: red;"
                    @click="handleDelete({
                      type:'sheet',
                      data:scope.row
                    })"
                  >
                    {{ $t("common.delete") }}
                  </p>
                </div>
              </el-popover>
            </template>
          </el-table-column>-->
        </CustomTable>
      </div>
    </div>

    <add-and-edit
      v-else
      :interface-title="interfaceTitle"
      :template-id="templateId"
      :attachment-id="attachmentId"
      @back="isMain = true"
    ></add-and-edit>

    <!-- 删除 -->
    <delete-dialog
      :visible.sync="deleteDialogVisible"
      :content="deleteContent"
      :loading.sync="deleteLoading"
      @confirm="handleConfirmDelete"
    />

    <!-- 数据表弹窗 -->
    <el-dialog
      v-dialogDrag
      :title="$t('excelConfiguration.dataSheet')"
      :visible.sync="dialogVisible"
      width="75%"
      @close="dialogClosed"
    >
      <div class="dialog-body">
        <CustomTable
          ref="customTable"
          :order="false"
          height="600px"
          :loading="tableLoading"
          :table-data="DataSources"
          @rowClick="rowClick"
          @handleSizeChange="handlePaginationChange"
          @handleCurrentChange="handlePaginationChange"
          @handleSelectionChange="SelectionChangeSheet"
        >
          <!-- 序号 -->
          <el-table-column width="80" :label="$t('excelConfiguration.serialNumber')">
            <template slot-scope="scope">
              <div>{{ scope.row.serialNumber }}</div>
            </template>
          </el-table-column>
          <!-- 英文表名 -->
          <el-table-column width="auto" :label="$t('excelConfiguration.englishTableName')">
            <template slot-scope="scope">
              <div>{{ scope.row.tableName }}</div>
            </template>
          </el-table-column>
          <!-- 表名称 -->
          <el-table-column width="auto" :label="$t('excelConfiguration.tableName')">
            <template slot-scope="scope">
              <div>{{ scope.row.tableDesc }}</div>
            </template>
          </el-table-column>
          >
          <!-- 选中状态 -->
          <el-table-column width="50">
            <template slot-scope="scope">
              <svg-icon
                v-show="dataIdentification === scope.row.tableName"
                icon-class="check-mark"
              ></svg-icon>
            </template>
          </el-table-column>
        </CustomTable>
      </div>
    </el-dialog>

    <!-- 属性设置弹窗 -->
    <el-dialog
      v-dialogDrag
      :title="$t('excelConfiguration.propertySetting')"
      :visible.sync="configSetDialogVisible"
      width="75%"
      destroy-on-close
      @close="configSetDialogClosed"
    >
      <property-setting
        v-if="configSetDialogVisible"
        :config-set-info="configSetInfo"
      ></property-setting>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination";
import DeleteDialog from "@/components/common/Dialogs/DeleteDialog";
import PropertySetting from "./components/new-property-setting";
import AddAndEdit from "./components/add-and-edit";
// import CellTooltip from "@/components/private/cell-tooltip";
import excel_api from "@/api/excel/excel";
import { mapGetters } from "vuex";

export default {
  name: "EquipAccountList",
  components: {
    DeleteDialog,
    Pagination,
    PropertySetting,
    AddAndEdit
    // CellTooltip,
  },
  data() {
    return {
      isMain: true,
      interfaceTitle: "",
      templateId: null,
      attachmentId: null,
      dataIdentification: "",
      dialogVisible: false,
      configSetDialogVisible: false,
      // 是否更新
      whetherList: [
        {
          value: true,
          label: "是"
        },
        {
          value: false,
          label: "否"
        }
      ],
      // 单条数据删除的数据
      singleData: {},
      // 单条数据删除的标识
      singleDeleteSign: "",
      // 批量标识
      batch: false,
      // 初始化sheet页的数据源
      selectionData: [],
      // sheet列表选中的数据源
      selectionSheetData: [],
      // 批量删除的数据
      deleteRows: [],
      // 数据表集合
      DataSources: [],
      changeDataSource: {},
      icon_save: require("@/assets/images/import-img/save.png"),
      icon_init: require("@/assets/images/import-img/init.png"),
      // 文件列表
      fileList: [],
      sheetList: [],

      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      tableLoading: false,
      deleteDialogVisible: false,
      deleteLoading: false,
      deleteContent: {
        title: "删除数据",
        description: "你确认删除选中的数据吗"
      },
      // 模板excel列表查询
      fileparam: {
        pageNum: 1,
        total: 0,
        pageSize: 20,
        search: ""
      },
      //
      configSetInfo: {}
    };
  },
  computed: {
    ...mapGetters(["tenantId"])
  },
  created() {
    this.getFileList(this.fileparam);
    console.log(this.$route);
  },
  methods: {
    // 获取弹窗表格选中的数据
    rowClick(data) {
      this.changeDataSource.tableDesc = data.tableDesc;
      this.changeDataSource.tableName = data.tableName;
      this.dialogClosed();
    },
    // 焦点事件，打开弹窗，请求数据
    blurSearch(data) {
      this.dataIdentification = data.tableName;
      this.changeDataSource = data;
      this.dialogVisible = true;
      this.getDataSources();
    },

    getDataSources() {
      const { datasourceId } = this.selectionData[0];
      excel_api.getDataSources(datasourceId).then(res => {
        if (res.success && res.code === 200) {
          this.DataSources = res.data;
          this.DataSources.map((item, index) => {
            item.serialNumber = index + 1;
          });
        } else {
          this.$message({
            message: "暂无数据",
            type: "warning"
          });
        }
      });
    },

    // 关闭弹框
    dialogClosed() {
      this.dialogVisible = false;
    },
    // 关闭属性设置弹框
    configSetDialogClosed() {
      this.configSetDialogVisible = false;
    },

    // file复选框的数据   手动修改为单选操作
    SelectionChange(data) {
      if (data.length === 0) {
        return;
      }
      if (data.length === 1 && data[0].id !== this.selectionData[0]?.id) {
        this.selectionData = data;
        this.getSheetBytemplateId();
        return;
      }
      if (data.length === 2 && this.selectionData.length === 1) {
        const obj = data.find(item => this.selectionData[0].id !== item.id);
        this.selectionData = [obj];
        this.getSheetBytemplateId();
        return;
      }
      if (data.length >= 2) {
        this.selectionData = [...this.selectionData];
      }
    },

    setCurrentRow(val) {
      this.selectionData = [val];
      this.getSheetBytemplateId();
    },
    //
    SelectionChangeSheet(data) {
      this.selectionSheetData = data;
    },

    /**
     * @description: 单条数据删除
     * @param {*} data {
     *        type: ”file“--文件列表的删除标识 ”sheet“--sheet列表的删除标识
     *        data:删除当前行的数据源
     *         }
     * @return {*}
     */
    handleDelete(data) {
      this.singleData = data.data;
      this.singleDeleteSign = data.type;
      this.deleteDialogVisible = true;
    },

    // 批量删除
    deleteFileListData(data) {
      this.deleteRows = data.map(res => res.id);
      this.deleteDialogVisible = true;
      this.batch = true;
      this.singleDeleteSign = "file";
    },

    deleteSheetListData(data) {
      this.deleteRows = data.map(res => res.id);
      this.deleteDialogVisible = true;
      this.batch = true;
      this.singleDeleteSign = "sheet";
    },

    // 确认删除
    handleConfirmDelete() {
      this.deleteLoading = true;
      const params = {};
      if (this.singleDeleteSign === "file" && !this.batch) {
        // file列表单个删除
        excel_api.delteConfiguration(this.singleData.id).then(res => {
          this.deleteLoading = false;
          this.deleteDialogVisible = false;
          this.getFileList(this.fileparam);
        });
      } else if (this.singleDeleteSign === "file" && this.batch) {
        // file列表批量删除
        params.keys = this.deleteRows;
        excel_api.delteBatchConfiguration(params).then(res => {
          this.deleteLoading = false;
          this.batch = false;
          this.deleteDialogVisible = false;
          this.getFileList(this.fileparam);
        });
      } else if (this.singleDeleteSign === "sheet" && !this.batch) {
        // sheet列表单个删除
        excel_api.deleteSheet(this.singleData.id).then(res => {
          this.deleteLoading = false;
          this.deleteDialogVisible = false;
          this.getSheetBytemplateId();
          // this.getFileList(this.fileparam);
        });
      } else {
        params.keys = this.deleteRows;
        excel_api.deletebatchSheet(params).then(res => {
          this.deleteLoading = false;
          this.batch = false;
          this.deleteDialogVisible = false;
          this.getSheetBytemplateId();
        });
      }
    },

    // 保存数据
    submitSaveData(data) {
      const params = [];
      const templateId = this.selectionData[0].id;
      if (data !== undefined) {
        //  单个数据的保存
        params.push(data);
        excel_api.saveSheetOfDatasource(params, templateId).then(res => {});
        this.handleAddRoleShow({
          type: "property",
          data
        });
      } else {
        if (this.selectionSheetData.length === 0) {
          this.$message({
            message: "请选择数据",
            type: "warning"
          });
          return;
        }
        //  批量数据的保存
        excel_api.saveSheetOfDatasource(this.selectionSheetData, templateId).then(res => {
          if (res.success && res.code === 200) {
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.getSheetBytemplateId();
          } else {
            this.$message({
              message: "保存失败",
              type: "warning"
            });
          }
        });
      }
    },

    tableRow(value) {},

    /**
     * @description: 添加/编辑/属性设置
     * @param {*} data {
     *        type: ”add“--新增， ”edit“--编辑，
     *                  }
     * @return {*}
     */
    handleAddRoleShow(data) {
      const rowData = data.data;
      if (data.type === "add" || data.type === "edit") {
        this.interfaceTitle = data.type === "add" ? "添加" : "编辑";
        this.templateId = rowData === null ? "null" : rowData.id;
        this.attachmentId = rowData === null ? "null" : rowData.attachmentId;
        this.isMain = false;
      } else if (data.type === "property") {
        if (rowData.tableName === null && rowData.tableDesc === null) {
          this.$message({
            message: "请选择表名称",
            type: "warning"
          });
          return;
        }
        this.configSetDialogVisible = true;
        this.configSetInfo = {
          InterfaceTitle: "属性设置",
          sheetId: rowData.id,
          tableName: rowData.tableName,
          datasourceId: this.selectionData[0].datasourceId
        };

        /*
         * this.$router.push({
         *   path: "/import/property-setting",
         *   query: {
         *     InterfaceTitle: "属性设置",
         *     sheetId: window.btoa(rowData.id),
         *     tableName: window.btoa(rowData.tableName),
         *     datasourceId: window.btoa(this.selectionData[0].datasourceId),
         *   },
         * });
         */
      }
    },

    /**
     * @description: 查询导入配置列表
     * @param {*} fileparam
     *
     * @return {*}
     */
    getFileList(fileparam) {
      const param = {
        size: fileparam.pageSize,
        page: fileparam.pageNum,
        "orders[0].asc": "false",
        "orders[0].column": "createTime",
        search: this.fileparam.search
      };
      excel_api.getConfigurationListOfPage(param).then(res => {
        this.fileList = res.data.records;
        fileparam.total = Number(res.data.total);
      });
    },

    // 搜索
    handleSearch() {
      this.fileparam.pageNum = 1;
      this.fileparam.total = 0;
      this.getFileList(this.fileparam);
    },

    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.getFileList(data);
    },

    // 查询模板sheet页
    getSheetBytemplateId() {
      if (this.selectionData.length > 1) {
        this.sheetList = [];

        /*
         * this.$message({
         *   message: "请选择一条excel模板数据",
         *   type: "warning",
         * })
         */
      } else if (this.selectionData.length === 0) {
        this.sheetList = [];
      } else {
        const templateId = this.selectionData[0].id;
        excel_api.getSheetBytemplateId(templateId).then(res => {
          this.sheetList = res.data;
        });
      }
    },
    // 初始化sheet页
    initSheetList() {
      if (this.selectionData.length > 1) {
        this.sheetList = [];
        this.$message({
          message: "请选择一条excel模板数据",
          type: "warning"
        });
      } else if (this.selectionData.length === 0) {
        this.sheetList = [];
        this.$message({
          message: "请选择excel模板数据",
          type: "warning"
        });
      } else {
        const templateId = this.selectionData[0].id;
        excel_api.initSheet(templateId).then(res => {
          if (res.success && res.code === 200) {
            this.$message({
              message: "初始化sheet成功",
              type: "success"
            });
            this.sheetList = res.data;
          } else {
            this.$message({
              message: "初始化sheet失败",
              type: "warning"
            });
          }
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.equip-account__content {
  padding: 24px;
}

::v-deep .scim-common-theme .self-dialog-form .el-dialog__body {
  overflow-y: hidden !important;
}
#import-configuration {
  .suffix_icon {
    width: 16px;
    height: 16px;
    margin-top: 6px;
    cursor: pointer;
  }
  .span_overflow {
    width: 100%;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>

<style lang="scss">
#import-configuration {
  .el-form {
    .el-input--small {
      .el-input__inner {
        padding-left: 8px;
      }
      .el-input__clear {
        line-height: 32px;
      }
    }
  }
}
#import-configuration .self-table td,
#import-configuration .self-table th {
  padding: 8px 0;
}
#import-configuration .el-form .el-button--small {
  padding: 9px 15px;
}
#import-configuration .sheet_table .el-input-group__append {
  color: #00b259;
}
</style>
